export default __webpack_public_path__ + "static/media/sass-logo.95acddf0.png";